import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {AccountTabsLayout} from "../../common/account-tabs-layout/account-tabs-layout";

export const AddressBookLayout = ({activeTab, next}) => cs(
    consumeContext("accountMenu"),
    consumeContext("apis"),
    consumeContext("company"),
    consumeContext("session"),
    ["mailerActive", ({company, session}, next) => next(
        !company?.prefs?.dynamicAccount ||
        session?.data?.agent?.activeAddressableOrMailableTemplate
    )],
    ["permitActive", ({company, session}, next) => next(
        (company?.prefs?.allowBulkMailPermit && session?.data?.branch?.allowBulkMailPermit) ||
        session?.data?.branch?.allowBulkMailPermit == 1
    )],
    ["assetsInactive", ({mailerActive, permitActive}, next) => next(
        !mailerActive && !permitActive
    )],
    ({accountMenu, assetsInactive}, next) => AccountTabsLayout({
        activeMenu: "addressBook",
        activeTab,
        config: accountMenu?.["addressBookMenu"]?.subMenu ?? getItems({assetsInactive}),
        next,
    }),
    ({}) => (
        <div className="address-book-layout-CaCO3">
            {next()}
        </div>
    ),
);


const getItems = ({assetsInactive}) =>  {
    return [
        {
            linkLabel: "Shipping Addresses",
            name : "shipping",
            link: "/account/address-book/shipping",
        },
        {
            linkLabel: "Address Lists",
            name : "mailing",
            link: "/account/address-book/address-lists",
        },
        {
            linkLabel: "Mailing Assets",
            name : "assets",
            link: "/account/address-book/mailing-assets",
        },
    ].filter((item) => !(item.name == "assets" && assetsInactive));
};
